import {
  Info,
  UsersRound,
  ShieldCheck,
  Users,
  MapPin,
  CarFront,
  FileText,
  Star,
  LayoutDashboard,
  Building,
  Building2,
  CircleUserRound,
  Map,
  Plane,
  MoveUp,
  Banknote,
  Tag,
  CreditCard,
  UserPlus,
  IdCard,
  TimerReset,
  CalendarClock,
  Calendar,
  Ban,
  LucideIcon,
  Car,
  Send,
  BriefcaseConveyorBelt
  // Unused imports removed for now (Car, IndianRupee, Hotel) 
} from "lucide-react";


import { ModuleKey } from "@/lib/moduleConfig";

export const iconsMap: Partial<Record<ModuleKey, LucideIcon>> = {
  // Dashboard & Company
  dashboard: LayoutDashboard,
  company: Building,
  my_inventory: BriefcaseConveyorBelt,

  // User & Role Management
  users: UsersRound,
  staff_management: Users,
  role_management: Users,
  relationship_manager: Users,
  passenger_details: UsersRound,
  passenger_rating: Star,
  blacklist_passenger: Ban,
  referrals: Users,
  user_management: CircleUserRound,
  user: CircleUserRound,
  driver: CircleUserRound,
  vendor: CircleUserRound,
  dmc: CircleUserRound,
  staff: CircleUserRound,
  add_staff: UserPlus,
  add_user_license: IdCard,
  department_job: FileText,
  applied_job: FileText,

 

  // Admin & Permissions
  admin_web_panel: ShieldCheck,

  // Booking & History
  booking: Calendar,
  booking_history: Calendar,
  booking_status_all: FileText,
  transport_booking: Calendar,
  activity_booking: Calendar,
  hotel_booking: Calendar,
  local: CarFront,
  point_to_point: Map,
  airport: Plane,
  outstation: MapPin,
  oneway: MoveUp,
  bid: Banknote,

  // Fare Management
  detailed_fare_history: FileText,
  fare_distance: FileText,
  fare_hourly: TimerReset,
  fare_distance_hour: FileText,
  fare_distance_waiting: FileText,
  commission_management: FileText,
  surcharges_management: FileText,
  time_management: CalendarClock,
  fare_management: Tag,
  cab_fare: Tag,
  view_local_package_fare: Tag,
  vendor_cab_fare: Tag,
  add_cab_fare: Tag,
  upload_fare: Tag,
  guide_fare: Tag,

  // Vehicles
  live_vehicle_mapping: MapPin,
  vehicle_management: CarFront,
  add_vehicle: CarFront,
  manage_vehicle: CarFront,
  manage_vehicle_mapping: CarFront,

  // Finance & Billing
  finance: Banknote,
  statement_of_account: Banknote,
  invoice: Banknote,
  payment_upload: Banknote,
  manage_masters: Banknote,
  credit_limit: Calendar,
  payment_report: CreditCard,
  billing_management: Banknote,
  credit_card_report: CreditCard,

  dispatch: Car,
  newsletter: Send,
  company_price: Building
};

export const getIcon = (key: ModuleKey): LucideIcon => {
  return iconsMap[key] ?? Info; // fallback to Info icon
};
